import { NavLink } from 'react-router-dom';

import { Divider, Group, ThemeIcon } from '@mantine/core';

import useAuth from '@hooks/useAuth';
import useLayoutProps from '@hooks/useLayoutProps';

import UserPermissionGuard from '@components/guards/UserPermissionGuard';

import { getLink, linksData } from '../../data/linksData';
import classes from './Home.module.css';

export default function Home() {
  const { user } = useAuth();

  useLayoutProps({
    title: `Benvenuto ${user?.name}`,
  });

  const links = linksData.map((item) => {
    if (item.type === 'divider') {
      return (
        <UserPermissionGuard
          key={item.dividerLabel}
          permission={item.requiredPermission || null}
          relatedOnly={item.relatedOnly}
          excludeRoles={item.excludeRoles}
        >
          <Divider
            label={item.dividerLabel}
            labelPosition="left"
            mt="lg"
            mb="xs"
            styles={(theme) => ({
              root: { width: '100%', padding: `0 ${theme.spacing.md}` },
              label: { fontSize: '1rem' },
            })}
          />
        </UserPermissionGuard>
      );
    }

    return (
      <UserPermissionGuard
        key={item.label}
        permission={item.requiredPermission || null}
        relatedOnly={item.relatedOnly}
        excludeRoles={item.excludeRoles}
      >
        <NavLink to={getLink(item.link, user)} className={classes.linkButton}>
          <ThemeIcon variant="transparent" size={25}>
            <item.icon style={{ width: '100%', height: '100%' }} />
          </ThemeIcon>
          <span>{item.label}</span>
        </NavLink>
      </UserPermissionGuard>
    );
  });

  return <Group>{links}</Group>;
}
